<template>
  <div class="box">
    <sc-form
      ref="form"
      :form="form"
      :rules="rules"
      :hasStyle="false"
      :buttonsStyle="false"
      @submit="onReleaseForPayment"
      is-edit>
      <template slot="fields" slot-scope="{ fields }">
        <sc-table
          :data="invoices"
          :per-page="pagination.limit"
          :checked-rows.sync="checkedInvoices"
          :row-class="() => 'sc-pre-invoice-audit-table__table__row'"
          class="sc-pre-invoice-audit-table"
          default-sort="order_number"
          default-sort-direction="asc"
          checkbox-position="right"
          paginated
          checkable
          scrollable>
          <template slot-scope="{ row }">
            <sc-table-column
              label="N° do Pedido"
              field="order_number"
              sortable>
              <a
                target="_blank"
                :href="`/ng#/order-number/${row.order_number}`"
                class="sc-recon-pre-invoice-table__table__link">
                {{ row.order_number }}
              </a>
            </sc-table-column>

            <sc-table-column
              label="Cod. Rastreamento"
              field="tracking_code"
              sortable>
              <a
                :href="`http://status-testing.intelipost.com.br/tracking/${row.tracking_code}`"
                target="_blank">
                {{ row.tracking_code }}
              </a>
            </sc-table-column>

            <sc-table-column
              label="Docto Transp"
              field="cte_number"
              sortable>
              <router-link
                target="_blank"
                :to="`/recon/invoice-detail/${row.id}?action=cte`"
                class="sc-pre-invoice-audit-table__table__link">
                {{ [row.cte.number, row.cte.serie].join('-') }}
              </router-link>
            </sc-table-column>

            <sc-table-column
              label="NF"
              field="invoice"
              sortable>
              <router-link
                target="_blank"
                :to="`/recon/invoice-detail/${row.id}?action=values`"
                class="sc-pre-invoice-audit-table__table__link">
                {{ [row.invoice.number, row.invoice.serie].join('-') }}
              </router-link>
            </sc-table-column>

            <sc-table-column
              label="Docto Cobrança"
              field="doccob"
              sortable>
              {{ [row.doccob.number, row.doccob.serie].join('-') }}
            </sc-table-column>

            <sc-table-column
              label="Status"
              field="status"
              sortable>
              {{ row.status.label }}
            </sc-table-column>

            <sc-table-column
              label="Valor da NF"
              field="invoice_value"
              sortable>
              {{ row.invoice.value | currency }}
            </sc-table-column>

            <sc-table-column
              label="Frete TMS"
              field="tms_value"
              sortable>
              <router-link
                target="_blank"
                :to="`/recon/invoice-detail/${row.id}?action=values`"
                class="sc-pre-invoice-audit-table__table__link">
                {{ row.tms_value | currency }}
              </router-link>
            </sc-table-column>

            <sc-table-column
              label="Frete Docto"
              field="cte_value"
              sortable>
              <router-link
                target="_blank"
                :to="`/recon/invoice-detail/${row.id}?action=values`"
                class="sc-pre-invoice-audit-table__table__link">
                {{ row.cte_value | currency }}
              </router-link>
            </sc-table-column>

            <sc-table-column
              label="Valor à Pagar"
              field="payment_type"
              :key="`table_form.${row.id}.payment_type`">
              <sc-field>
                <sc-select
                  v-if="canSelectPaymentType(row)"
                  v-model="getInvoiceById(fields, row.id).payment_type"
                  expanded>
                  <option value="tms_value">TMS</option>
                  <option value="cte_value">CTE</option>
                </sc-select>
                <p v-else>-</p>
              </sc-field>
            </sc-table-column>
          </template>

          <template slot="footer">
            <p v-if="totalCount">
              <strong>Total de registros:</strong>
              <span>{{ totalCount }}</span>
            </p>
          </template>

          <template slot="bottom-left">
            <sc-table-per-page v-model="pagination.limit" />
          </template>
        </sc-table>

        <div class="sc-form__footer columns sc-pre-invoice-audit-table__footer">
          <div class="column">
            <div class="buttons is-right">
              <sc-button
                @click="onReverseClick"
                theme="danger"
                text="Estornar" />

              <sc-button
                type="submit"
                theme="primary"
                text="Liberar pagamento" />
            </div>
          </div>
        </div>
      </template>
    </sc-form>
  </div>
</template>

<script>
import {
  ScDialog,
  ScField,
  ScInput,
  ScInputCurrency,
  ScSelect,
  ScButton,
  ScForm,
  ScTable,
  ScTableColumn,
  ScTablePerPage,
  ScToast,
} from '@intelipost-js/secure-components';

export default {
  name: 'sc-pre-invoice-audit-table',
  props: {
    form: {
      type: [Object, null],
      required: true,
    },
    invoices: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      checkedInvoices: [],
      rules: {},
      pagination: {
        limit: 10,
      },
      canSelectPaymentTypeStatus: [
        'WAITING_PAYMENT_READY',
      ],
      canReleaseForPaymentStatus: [
        'WAITING_PAYMENT_READY',
        'READY_FOR_PAYMENT',
      ],
      canReverseInvoice: [
        'WAITING_LP_APPROVE',
        'WAITING_PAYMENT_READY',
      ],
    };
  },
  computed: {
    totalCount() {
      return this.invoices && this.invoices.length;
    },
  },
  methods: {
    getInvoiceById(fields, id) {
      return fields.table_form[id] || {};
    },
    canSelectPaymentType(field) {
      const { status } = field || {};
      const { value } = status || {};

      return this.canSelectPaymentTypeStatus.indexOf(value) !== -1;
    },
    checkAllowedIds(checkedItems, allowedStatusList) {
      const allowedIds = checkedItems.filter(({ status }) => allowedStatusList
        .indexOf(status.value) !== -1)
        .map(({ id }) => id);

      const notAllowedIds = checkedItems.filter(({ status }) => allowedStatusList
        .indexOf(status.value) === -1)
        .map(({ id }) => id);

      return {
        allowed: allowedIds,
        notAllowed: notAllowedIds,
      };
    },
    confirmSendAllowed(ids, type = 'payment', onConfirm) {
      const {
        ids: htmlIds,
        action,
        title,
      } = this.getConfirmData(ids, type);

      ScDialog.confirm({
        title,
        message: `
          Algumas faturas selecionadas <b>não podem</b> ser ${action}. Deseja prosseguir com as demais?
          <br /><br />
          Faturas que serão ${action}: ${htmlIds}
        `,
        cancelText: 'Cancelar',
        confirmText: title,
        type: 'is-danger',
        onConfirm,
      });
    },
    getConfirmData(ids, type = 'payment') {
      const htmlIds = Array.isArray(ids) && ids
        .map(id => `<b>${id}</b>`)
        .join(', ');

      const typeAction = `${type === 'payment' ? 'liberaradas para pagamento' : 'estornadas'}`;
      const typeTitle = `${type === 'payment' ? 'Liberar pagamento' : 'Estornar'}`;

      return {
        ids: htmlIds,
        action: typeAction,
        title: typeTitle,
      };
    },
    onReleaseForPayment() {
      const {
        allowed,
        notAllowed,
      } = this.checkAllowedIds(this.checkedInvoices, this.canReleaseForPaymentStatus);

      if (this.checkedInvoices.length === 0) {
        ScToast.danger('Selecione pelo menos uma fatura para liberar o pagamento.');
        return false;
      }

      if (allowed.length === 0) {
        ScToast.danger('As faturas selecionadas não podem ser liberadas para pagamento. Verifique o status.');
        return false;
      }

      if (Array.isArray(notAllowed) && notAllowed.length > 0) {
        const onConfirm = () => this.$emit('releaseForPayment', this.checkedInvoices);

        this.confirmSendAllowed(allowed, 'payment', onConfirm);

        return false;
      }

      this.$emit('releaseForPayment', this.checkedInvoices);

      return true;
    },
    onReverseClick() {
      const {
        allowed,
        notAllowed,
      } = this.checkAllowedIds(this.checkedInvoices, this.canReverseInvoice);

      if (this.checkedInvoices.length === 0) {
        ScToast.danger('Selecione pelo menos uma fatura para estornar.');

        return false;
      }

      if (allowed.length === 0) {
        ScToast.danger('As faturas selecionadas não podem ser estornadas. Verifique o status.');

        return false;
      }

      if (Array.isArray(notAllowed) && notAllowed.length > 0) {
        const onConfirm = () => this.$emit('reversePreInvoices', this.checkedInvoices);

        this.confirmSendAllowed(allowed, 'reverse', onConfirm);

        return false;
      }

      const idsToReverse = this.checkedInvoices.map(({ id }) => `<b>${id}</b>`).join(', ');

      ScDialog.confirm({
        title: 'Estornar pré-faturas',
        message: `As faturas selecionadas serão estornadas e retornarão para
          a etapa de aprovação:<br /><br />${idsToReverse}`,
        cancelText: 'Cancelar',
        confirmText: 'Estornar',
        type: 'is-danger',
        onConfirm: () => this.$emit('reversePreInvoices', this.checkedInvoices),
      });

      return true;
    },
  },
  components: {
    ScField,
    ScInput,
    ScInputCurrency,
    ScSelect,
    ScButton,
    ScForm,
    ScTable,
    ScTableColumn,
    ScTablePerPage,
    ScToast,
  },
};
</script>

<style lang="scss">
$row-danger: #feecf0;
$row-warning: #fffbeb;
$row-success: #effaf3;

.sc-pre-invoice-audit-table {
  .table-wrapper {
    overflow: auto;
    overflow-y: hidden;
    max-width: 100%;
    border-right: 2px solid #e7e7e7;
  }

  &__notification {
    &--is-warning {
      background-color: #fffbeb;
      color: #947600;
    }
  }

  &__table {
    &__row {
      td {
        white-space: nowrap;

        .field {
          min-width: 130px;
          margin-left: auto;
          margin-right: auto;
        }
      }

      &--danger {
        td {
          background-color: $row-danger;
        }

        &:hover {
          td {
            background-color: darken($row-danger, 1);
          }
        }
      }

      &--warning {
        td {
          background-color: $row-warning;
        }

        &:hover {
          td {
            background-color: darken($row-warning, 2);
          }
        }
      }

      &--success {
        td {
          background-color: $row-success;
        }

        &:hover {
          td {
            background-color: darken($row-success, 2);
          }
        }
      }
    }

    &__link {
      font-weight: bold;

      &--danger {
        color: #e84c3d;
      }

      &--warning {
        color: #bca316;
      }
    }
  }

  &__footer {
    &.sc-form__footer {
      margin: 1.25rem -1.25rem -1.25rem -1.25rem;
      padding: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/components/sc-pre-invoice-audit-table/ScPreInvoiceAuditTable.vue?08aed906